import * as $ from 'jquery';
import { ChartBase } from "./ChartBase";

export class CreditLimitsGraph extends ChartBase {
    protected organizationId: string;
    private apiUrl: string;

    constructor(private container: JQuery) {
        super(container);
        this.canvasId = "credit-limits-graph-canvas";
        this.organizationId = container.attr('data-organization-id');
        this.apiUrl = container.attr('data-api-url');
        
        this.configuration = $.extend(true, {}, this.configuration, {
            type: 'line',
            legend: {
                display: false,
                responsive: false
            },
            options: {
                scales: {
                    yAxes: [{
                        ticks: {
                            autoSkip: true,
                            callback: function (value, index, values) {
                                return `${value} kr`;
                            }
                        }
                    }],
                    xAxes: [{
                        type: 'time',
                        time: {
                            unit: 'month',
                            displayFormats: {
                                quarter: 'mm YYYY'
                            }
                        },
                        scaleLabel: {
                            fontSize: 9,
                        },
                        ticks: {
                            font: {
                                size: 9
                            }
                        }
                        
                    }]
                },
                legend: {
                  display: false  
                },
                tooltips: {    
                    displayColors: false,
                    callbacks: {
                        title: function (item, data) {
                            let datepart = item[0].label.substring(0, 10)
                            var formatted = new Intl.DateTimeFormat("no").format(new Date(datepart));
                            return `${formatted}`;
                        },
                        label: function (item, data) {
                            return `${item.value} kr`
                        }
                    }
                },
                plugins: {
                    datalabels: {
                        display: false
                    },
                    legend: {
                        display: false
                    }
                }
            },
        });

        this.initialize();
    }

    private initialize() {
        let that = this;
        this.getCreditLimits().then(response => {
            let dates = response.CreditLimits.map(u => u.Date);
            let uniqueDates = [...new Set(dates)];
            let labels = uniqueDates.map(u => u.toString());
          
            this.configuration.data.datasets.push({
                data: response.CreditLimits.map(u => u.Amount),
                borderColor: "#3284bf", 
            });
            this.configuration.data.labels = labels;
        }).then(function () {
            that.drawChart();
        });
    }

    private async getCreditLimits(): Promise<YearlyCreditLimitResponse> {
        return $.ajax({
            type: 'GET',
            url: `${this.apiUrl}?organizationId=${this.organizationId}`,
            contentType: "application/json",
            success: function (data) {
                return data;
            },
            error: function (data) {
                window.console.log('error', data);
            }
        });
    }
}

export class YearlyCreditLimitResponse {
    public CreditLimits: CreditLimitViewModel[];
}

export class CreditLimitViewModel
{
    public Date: Date;
    public Amount: number;
    public Currency: string;
}